class APINetworkError extends Error {
  constructor(message) {
    super(message)
    this.name = 'APINetworkError'
  }
}

export default APINetworkError
